import { Box, styled } from "@mui/material";

export const Card = styled(Box)(({ theme }) => ({
    display: "flex",
    flex: 1,
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: theme.palette.core.grey._10,
    borderRadius: theme.shape.borderRadius,
    padding: `${theme.spacing(5)} ${theme.spacing(6)}`,
    boxShadow: theme.shadow.boxShadow.sm,
    userSelect: "none",
    overflow: "hidden",

    "&:hover": {
        boxShadow: theme.shadow.boxShadow.lg,
        cursor: "pointer",
    },
}));

export const RowContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    flex: 1,
    justifyContent: "space-between",
    alignItems: "center",
    userSelect: "none",
    padding: `${theme.spacing(4)} ${theme.spacing(4)}`,

    "&:hover": {
        backgroundColor: theme.palette.core.grey._20,
        cursor: "pointer",
    },
}));

export const RightContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
    paddingLeft: theme.spacing(2),
}));

export const LeftContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
}));
